import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { exists } from '@utils/functions.js'

export const initialState = []

export const toast = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.ADD_TOAST, (state, action) => addToast(state, action))
    .addCase(ActionTypes.REMOVE_TOAST, (state, action) => removeToast(state, action))
})

export default toast

function addToast(state, action) {
  const { payload } = action
  if (exists(payload)) {
    state.push(payload)
  }
  return state
}

function removeToast(state, action) {
  const { payload: uid } = action
  if (exists(uid)) {
    state.splice(
      state.findIndex(item => item.uid === uid),
      1
    )
  }
  return state
}
